import { ChevronDown, ClipboardCheck, BarChart3 } from 'lucide-react';
import SidebarNavItem from './SidebarNavItem';

// Lowest-traffic items — hidden behind a "More" disclosure.
export const MORE_ITEMS = [
  { path: '/review', label: 'Review', icon: ClipboardCheck, note: 'Daily close' },
  { path: '/analytics', label: 'Analytics', icon: BarChart3, note: 'Control room' },
];

/**
 * Collapsible "More" nav group with a summed unread badge when closed.
 */
export function SidebarMoreSection({ moreOpen, onToggle, counts, expanded, isActive, onNavigate }) {
  const badgeSum = MORE_ITEMS.reduce((n, it) => n + (it.countKey ? (counts[it.countKey] || 0) : 0), 0);

  return (
    <div className="mb-1 mt-1">
      {expanded ? (
        <button
          data-testid="sidebar-more-toggle"
          onClick={onToggle}
          className="w-full flex items-center gap-2 px-2 pt-3 pb-1 text-[9px] uppercase tracking-[0.14em] font-semibold"
          style={{ color: 'var(--pd-subtle)' }}
        >
          <span>More</span>
          <ChevronDown
            className="w-3 h-3 transition-transform"
            style={{ transform: moreOpen ? 'rotate(0deg)' : 'rotate(-90deg)' }}
          />
          {!moreOpen && badgeSum > 0 ? (
            <span
              data-testid="sidebar-more-badge"
              className="ml-auto min-w-[18px] h-[16px] rounded-full flex items-center justify-center text-[9px] font-bold text-white px-1"
              style={{ background: 'var(--pd-focus)' }}
            >{badgeSum > 99 ? '99+' : badgeSum}</span>
          ) : null}
        </button>
      ) : null}
      {(moreOpen || !expanded) && (
        <div className="space-y-0.5">
          {MORE_ITEMS.map((item) => (
            <SidebarNavItem
              key={item.path}
              item={item}
              active={isActive(item.path)}
              expanded={expanded}
              count={item.countKey ? (counts[item.countKey] || 0) : 0}
              isUrgent={false}
              onClick={() => onNavigate(item.path)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
